/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Agent_CalloutInputs */

const en_directory_submit_agent_callout = /** @type {(inputs: Directory_Submit_Agent_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping with an AI agent? Skip the form — paste this line into your agent instead:`)
};

const zh_directory_submit_agent_callout = /** @type {(inputs: Directory_Submit_Agent_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 AI agent 开发的？免填表单——把下面这行直接交给你的 agent：`)
};

/**
* | output |
* | --- |
* | "Shipping with an AI agent? Skip the form — paste this line into your agent instead:" |
*
* @param {Directory_Submit_Agent_CalloutInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_agent_callout = /** @type {((inputs?: Directory_Submit_Agent_CalloutInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Agent_CalloutInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_agent_callout(inputs)
	return zh_directory_submit_agent_callout(inputs)
});
export { directory_submit_agent_callout as "directory.submit.agent_callout" }